import { render, staticRenderFns } from "./ServiceCoverField.vue?vue&type=template&id=5f72a7c0&scoped=true"
import script from "./ServiceCoverField.vue?vue&type=script&lang=js"
export * from "./ServiceCoverField.vue?vue&type=script&lang=js"
import style0 from "./ServiceCoverField.vue?vue&type=style&index=0&id=5f72a7c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f72a7c0",
  null
  
)

export default component.exports